/**
 * Footer Accordion functionality for mobile devices
 * Handles the accordion behavior for footer menu blocks on screens max-width: 749px
 */

class FooterAccordion {
  constructor() {
    this.init();
  }

  init() {
    // Only initialize on mobile devices
    if (window.innerWidth <= 749) {
      this.setupAccordion();
    }

    // Re-initialize on window resize
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    const footerMenus = document.querySelectorAll('.footer-block--menu');
    
    if (window.innerWidth <= 749) {
      // Mobile: setup accordion
      this.setupAccordion();
    } else {
      // Desktop: remove accordion functionality
      this.removeAccordion(footerMenus);
    }
  }

  setupAccordion() {
    const footerMenus = document.querySelectorAll('.footer-block--menu');
    
    footerMenus.forEach((menu) => {
      const heading = menu.querySelector('.footer-block__heading');
      const content = menu.querySelector('.footer-block__details-content');
      
      if (!heading || !content) return;

      // Remove existing event listeners to avoid duplicates
      const newHeading = heading.cloneNode(true);
      heading.parentNode.replaceChild(newHeading, heading);

      // Close all menus by default on mobile
      menu.classList.remove('accordion-open');
      
      // Add click event listener to the heading
      newHeading.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(menu);
      });

      // Add keyboard support
      newHeading.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleAccordion(menu);
        }
      });

      // Make heading focusable for accessibility
      newHeading.setAttribute('tabindex', '0');
      newHeading.setAttribute('role', 'button');
      newHeading.setAttribute('aria-expanded', 'false');
      
      // Set up content for screen readers
      content.setAttribute('aria-hidden', 'true');
    });
  }

  removeAccordion(footerMenus) {
    footerMenus.forEach((menu) => {
      const heading = menu.querySelector('.footer-block__heading');
      const content = menu.querySelector('.footer-block__details-content');
      
      if (!heading || !content) return;

      // Remove accordion classes
      menu.classList.remove('accordion-open');
      
      // Remove accessibility attributes
      heading.removeAttribute('tabindex');
      heading.removeAttribute('role');
      heading.removeAttribute('aria-expanded');
      content.removeAttribute('aria-hidden');
      
      // Remove event listeners by cloning the element
      const newHeading = heading.cloneNode(true);
      heading.parentNode.replaceChild(newHeading, heading);
    });
  }

  toggleAccordion(menu) {
    const isOpen = menu.classList.contains('accordion-open');
    const heading = menu.querySelector('.footer-block__heading');
    const content = menu.querySelector('.footer-block__details-content');
    
    if (isOpen) {
      // Close the accordion
      menu.classList.remove('accordion-open');
      heading.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    } else {
      // Close all other accordions first (optional - remove if you want multiple open)
      const allMenus = document.querySelectorAll('.footer-block--menu');
      allMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) {
          otherMenu.classList.remove('accordion-open');
          const otherHeading = otherMenu.querySelector('.footer-block__heading');
          const otherContent = otherMenu.querySelector('.footer-block__details-content');
          if (otherHeading) otherHeading.setAttribute('aria-expanded', 'false');
          if (otherContent) otherContent.setAttribute('aria-hidden', 'true');
        }
      });
      
      // Open the current accordion
      menu.classList.add('accordion-open');
      heading.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    }
  }
}

// Initialize the accordion when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FooterAccordion();
});

// Also initialize if the script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FooterAccordion();
  });
} else {
  new FooterAccordion();
}
